import { createFileRoute } from '@tanstack/react-router'
import { SectionHeader, useSiteScope } from '../../-section'
import { ProspectTable } from '../-parts'

export const Route = createFileRoute('/_app/$org/$host/outreach/_list/accepted')({
  component: AcceptedPage,
})

function AcceptedPage() {
  const { org, host, site } = useSiteScope()
  return (
    <>
      <SectionHeader title="Accepted" />
      <ProspectTable
        site={site}
        org={org}
        host={host}
        view="accepted"
        empty={{
          title: 'Nothing accepted',
          description: `No thread for ${host} has ended in a yes.`,
        }}
      />
    </>
  )
}
